import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Helper: set a deeply nested key on an object using a path array
function setDeep(obj, pathParts, value) {
  let current = obj;
  for (let i = 0; i < pathParts.length - 1; i++) {
    const part = pathParts[i];
    if (!current[part] || typeof current[part] !== 'object') {
      current[part] = {};
    }
    current = current[part];
  }
  current[pathParts[pathParts.length - 1]] = value;
}

// Dynamically load all locale files
const locales = require.context('./locales', true, /\.json$/);
const messages = locales.keys().reduce((acc, key) => {
  // Match views (supports subfolders: en/views/blog/post-name.json)
  const matchedView = key.match(/\.\/([a-z]{2})\/views\/(.+)\.json$/);
  if (matchedView) {
    const [, locale, viewPath] = matchedView;
    if (!acc[locale]) acc[locale] = {};
    // viewPath may be 'home' or 'blog/why-we-built-kootto'
    // Split into parts and build nested object
    const parts = viewPath.split('/');
    setDeep(acc[locale], parts, locales(key));
    return acc;
  }

  // Match components (supports subfolders: en/components/dashboard/profile.json)
  const matchedComponent = key.match(/\.\/([a-z]{2})\/components\/(.+)\.json$/);
  if (matchedComponent) {
    const [, locale, componentPath] = matchedComponent;
    if (!acc[locale]) acc[locale] = {};
    const parts = componentPath.split('/');
    setDeep(acc[locale], parts, locales(key));
  }

  return acc;
}, {});

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: 'en',
  messages,
});

export default i18n;
